module.exports = __webpack_public_path__ + "assets/media/DEFAULT_PROFILE_IMAGE_ON_HOVER.978ef69d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/DEFAULT_PROFILE_IMAGE_ON_HOVER.svg
// module id = 2013
// module chunks = 0